module.exports = parseInt;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/math/to-integer.js
// module id = 149
// module chunks = 0 1 2